module.exports = __webpack_public_path__ + "img/14.564b9371.jpg";